import './styles.css';
import FadeInSection from "./FadeInSection";

function AboutPage( {sectionOneRef} ) {
    return (
        <div id={"AboutPage"}>
            <FadeInSection>
                <div className={'full'} id={"AboutPagePage"}>
                    <div id={"AboutPageLeft"}>
                        <h4>One Call Away From Fast,<br/>Reliable Support</h4>
                        <p style={{margin: '40px 0 10px 0'}}>
                            At Williams & Williams, we pride ourselves on efficient and well-rounded customer support.
                            Our
                            excellent team members work personally on each case to ensure specialized care is provided
                            to
                            each
                            and every client.
                        </p>
                        <div className={'container'}>
                            <h3>Call Today For a Free Consultation</h3>
                        </div>
                        <div style={{margin: '60px 0', position: 'relative', right: '10px'}}>
                            <p style={{margin: '10px 0 15px 12px', fontSize: '1.8em'}}>Areas of Practice</p>
                            <div id={'aboutCards'} className={'full'}>
                                <div className={'selector'} style={{borderTop: '1px solid grey'}}>
                                    <h5>Road Accidents</h5>
                                </div>
                                <div className={'dropdown-info'}>
                                    <p>
                                        Automobile and Truck Accidents, Pedestrian Accidents, Metro / WMATA Accidents
                                        and
                                        Injuries
                                    </p>
                                </div>
                                <div className={'selector'}>
                                    <h5>Workplace Incidents</h5>
                                </div>
                                <div className={'dropdown-info'}>
                                    <p>
                                        Workplace Injuries / Workers Compensation, Employment Disputes / Wrongful
                                        Termination
                                    </p>
                                </div>
                                <div className={'selector'}>
                                    <h5>Medical Care</h5>

                                </div>
                                <div className={'dropdown-info'}>
                                    <p>
                                        Medical Malpractice, Nursing Home Negligence
                                    </p>
                                </div>
                                <div className={'selector'}>
                                    <h5>Accidents and Negligence</h5>

                                </div>
                                <div className={'dropdown-info'}>
                                    <p>
                                        Wrongful Death, Slip and Fall Injuries
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id={'hoursHome'}>
                        <h2 style={{marginTop: '0'}}>Phone Numbers</h2>
                        <div>
                            <p>Law Office</p>
                            <a href={"tel:3019519525"}>(301) 951-9525</a>
                        </div>
                        <div>
                            <p>Andrew Williams</p>
                            <a href={"tel:2022963320"}>(202) 296-3320</a>
                        </div>
                        <div>
                            <p>Kevin Williams</p>
                            <a href={"tel:2022963320"}>(202) 296-3320</a>
                        </div>

                        <h2>Emails</h2>
                        <div>
                            <a href={'mailto:office@williamslawgroup.com'}>office@williamslawgroup.com</a>
                        </div>
                        <div>
                            <a href={'mailto:Andrew@williamslawgroup.com'}>Andrew@williamslawgroup.com</a>
                        </div>
                        <div>
                            <a href={'mailto:Kevin@williamslawgroup.com'}>Kevin@williamslawgroup.com</a>
                        </div>

                        <h2>Hours</h2>
                        <div>
                            <p>Monday:</p>
                            <p>9:00am - 5:00pm</p>
                        </div>
                        <div>
                            <p>Tuesday:</p>
                            <p>9:00am - 5:00pm</p>
                        </div>
                        <div>
                            <p>Wednesday:</p>
                            <p>9:00am - 5:00pm</p>
                        </div>
                        <div>
                            <p>Thursday:</p>
                            <p>9:00am - 5:00pm</p>
                        </div>
                        <div>
                            <p>Friday:</p>
                            <p>9:00am - 5:00pm</p>
                        </div>
                        <div>
                            <p>Saturday:</p>
                            <p>Closed</p>
                        </div>
                        <div>
                            <p>Sunday:</p>
                            <p>Closed</p>
                        </div>
                    </div>
                </div>
            </FadeInSection>
        </div>
    );
}

export default AboutPage;
